(function () {
  'use strict';

  const PDP_FORM_SELECTOR = 'form[is="product-form"]';
  const CLICK_ACTION_SELECTOR = '[data-complete-set-action]';
  const POPUP_SELECTOR = '[data-complete-set-popup]';
  const CLOSE_TRIGGER_SELECTOR = '[data-complete-set-close]';
  const VARIANT_SELECT_SELECTOR = '[data-complete-set-variant-select]';
  const PRICE_SELECTOR = '[data-complete-set-price]';
  const UPGRADE_ACTION_SELECTOR = '[data-complete-set-action="upgrade"]';
  const CLOSING_ANIMATION_MS = 360;

  const stateByPopup = new Map();

  function getConfig(form) {
    return form?.querySelector('[data-complete-set-config]') || null;
  }

  function getPopupById(popupId) {
    if (!popupId) return null;
    return document.getElementById(popupId);
  }

  function getVariantInput(form) {
    return form?.querySelector('input[name="id"]') || null;
  }

  function shouldHandleForm(form) {
    if (!form?.matches(PDP_FORM_SELECTOR)) return false;
    const config = getConfig(form);
    if (!config) return false;
    if (config.dataset.completeSetEnabled !== 'true') return false;
    return Boolean(form.closest('.shopify-section--main-product'));
  }

  function lockScroll() {
    document.documentElement.classList.add('complete-set-popup-lock');
  }

  function unlockScroll() {
    if (document.querySelector(`${POPUP_SELECTOR}.is-open`)) return;
    document.documentElement.classList.remove('complete-set-popup-lock');
  }

  function openPopup(popup) {
    if (!popup) return;
    popup.classList.remove('is-closing');
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function closePopup(popup, callback) {
    if (!popup || !popup.classList.contains('is-open')) {
      if (typeof callback === 'function') callback();
      return;
    }

    popup.classList.add('is-closing');

    window.setTimeout(() => {
      popup.classList.remove('is-open', 'is-closing');
      popup.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (typeof callback === 'function') callback();
    }, CLOSING_ANIMATION_MS);
  }

  function submitOriginalProduct(form) {
    form.dataset.completeSetBypass = 'true';
    form.requestSubmit();
    form.dataset.completeSetBypass = 'false';
  }

  function submitSetProduct(form, popup) {
    const config = getConfig(form);
    const upgradeButton = popup?.querySelector(UPGRADE_ACTION_SELECTOR);
    const setVariantId = upgradeButton?.dataset.completeSetVariantId || config?.dataset.completeSetVariantId;
    const variantInput = getVariantInput(form);

    if (!setVariantId || !variantInput) {
      submitOriginalProduct(form);
      return;
    }

    const originalVariantId = variantInput.value;
    variantInput.disabled = false;
    variantInput.value = setVariantId;

    form.dataset.completeSetBypass = 'true';
    form.requestSubmit();
    form.dataset.completeSetBypass = 'false';

    // Restore the original variant so the page UI remains tied to selected options.
    variantInput.value = originalVariantId;
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!shouldHandleForm(form)) return;
      if (form.dataset.completeSetBypass === 'true') return;

      const config = getConfig(form);
      const popup = getPopupById(config?.dataset.completeSetDrawerId);
      if (!popup) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      stateByPopup.set(popup.id, { form });
      openPopup(popup);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(CLICK_ACTION_SELECTOR);
    if (!trigger) return;

    const popupId = trigger.dataset.completeSetDrawerId;
    const popup = getPopupById(popupId);
    const state = popupId ? stateByPopup.get(popupId) : null;
    const form = state?.form;

    if (!form) return;

    const action = trigger.dataset.completeSetAction;
    closePopup(popup, () => {
      if (action === 'upgrade') {
        submitSetProduct(form, popup);
        return;
      }

      submitOriginalProduct(form);
    });
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest(VARIANT_SELECT_SELECTOR);
    if (!variantSelect || variantSelect.disabled) return;

    const popup = variantSelect.closest(POPUP_SELECTOR);
    if (!popup) return;

    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (!selectedOption) return;

    const upgradeButton = popup.querySelector(UPGRADE_ACTION_SELECTOR);
    if (upgradeButton && variantSelect.value) {
      upgradeButton.dataset.completeSetVariantId = variantSelect.value;
    }

    const priceElement = popup.querySelector(PRICE_SELECTOR);
    const formattedPrice = selectedOption.dataset.variantPriceFormatted;
    if (priceElement && formattedPrice) {
      priceElement.textContent = formattedPrice;
    }
  });

  document.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest(CLOSE_TRIGGER_SELECTOR);
    if (!closeTrigger) return;

    const popup = closeTrigger.closest(POPUP_SELECTOR);
    closePopup(popup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openPopupElement = document.querySelector(`${POPUP_SELECTOR}.is-open`);
    if (!openPopupElement) return;

    closePopup(openPopupElement);
  });
})();
